import { endpoints } from '../../../environments/endpoints';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadEmployeesService {

  constructor(private http: HttpClient) { }

  upload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);


    const req = new HttpRequest(
      'POST',
      environment.api.host + endpoints.employeesUpload,
      formData,
      {
        reportProgress: true
      }
    );

    return this.http.request(req);
  }

  getFile(key: string): Observable<any> {
    return this.http.get(environment.api.host + endpoints.getFile + '/' + key);
  }

  exportTemplate(country_id: number): Observable<Blob> {

      return this.http.get(environment.api.host + endpoints.employeesExportTemplate+'/'+country_id,
      { responseType: 'blob' }
      ).pipe(
        map(res => res),
        catchError(this.handleError)
      );
  }


  exportLastImportedFile(country_id: number): Observable<Blob> {
    return this.http.get(environment.api.host + endpoints.employeesExportLastImportedFile+'/'+country_id,
    { responseType: 'blob' }
    ).pipe(
      map(res => res),
      catchError(this.handleError)
    );
  }

  exportImportedFile(id: number): Observable<Blob> {
    return this.http.get(environment.api.host + endpoints.employeesExportImportedFile+'/'+id,
    { responseType: 'blob' }
    ).pipe(
      map(res => res),
      catchError(this.handleError)
    );
  }


  getImportHistory(country_id: number): Observable<any> {
		return this.http.get(environment.api.host + endpoints.employeesGetImportHistory +'/'+country_id).pipe(
			map(
				(res: any) => res.data
			),
			catchError(this.handleError)
		);
	}

  

  protected handleError(error: any): Promise<any> {
		if (error.status === 401) {
			window.location.reload();
		}

		return Promise.reject(error?.error?.message || error?.message || error);
	}


}
